

exports.__esModule = true;
exports.$xoCvvDirective = undefined;

var _squid = require('squid');

var _cardMetaData = require('../cardMetaData');

var _template = require('./template.html');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCvvDirective = exports.$xoCvvDirective = _squid.$Component.extend('$xoCvvDirective', {
    tag: 'xo-cvv',
    template: _template2['default'],

    props: {
        card: {
            type: 'var'
        },
        showLabel: {
            type: 'var'
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.maskCVV = (0, _squid.$feature)('maskCVV', false, _squid.$locale.country);
            this.cvvLength = function () {
                return _cardMetaData.$CardMetaData.getMetaData(_this.props.card, 'length.cvv');
            };
            this.cvvRequired = function () {
                return _this.props.card.type !== 'MAESTRO' || (0, _squid.$feature)('maestroCvvRequired', false, _squid.$locale.country);
            };
        }
    }
});

angular.value("$xoCvvDirective", $xoCvvDirective);
_squid.$Component;

_squid.$locale;

_squid.$feature;

_cardMetaData.$CardMetaData;


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-wallet-components/src/add-card/cvv/directive.js
 ** module id = 229
 ** module chunks = 1
 **/